import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useGet from "./useGet";
import useUpdate from "./useUpdate";
import { EditActionContext } from "./EditActionContext";
import InvoiceForm from "../../components/InvoiceForm";

function useEditAction(index: any, formDefaultValues: any = {}, formWidgets: any = {}, invoiceConfiguration: any = {}, showReceiverAccountSelector = true): any {
  const get = useGet();
  const getFunction = (id: number) => get(id, formDefaultValues);

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = () => {
    setShowModal(false);
    index(); // We pass the function to refresh the table on success
  };

  const update = useUpdate();
  const updateFunction = () => update(onSuccessUpdate);

  /** Creation and edition modal function and state definition */
  const contextInstance = useContext(EditActionContext);
  const { setShowModal } = contextInstance;

  /** Creation and edition modal element definition */
  const { element } = contextInstance;

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: "edit_invoice",
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
    size: "modal-xl",
    fullscreen: true as true,
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      updateFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: EditActionContext,
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <InvoiceForm formConfig={formConfig} formWidgets={formWidgets} invoiceConfiguration={invoiceConfiguration} showReceiverAccountSelector={showReceiverAccountSelector}/>
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    getFunction,
    actionTemplate,
  };
}

export default useEditAction;
